/** Lo primero que se ve: los números, lo que me toca y lo último que ha pasado. */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { ErrorDeApi, api } from '../api'
import { Cargando, Cifra, EtiquetaDeEstado, EtiquetaDePrioridad, Error, Vacio } from '../componentes/piezas'
import { usePortal } from '../contexto'
import { fecha, hace } from '../textos'
import type { Portada as Datos } from '../tipos'

export default function Portada() {
  const { ruta, servidor, yo, puedo } = usePortal()
  const [datos, setDatos] = useState<Datos | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    setDatos(null)
    api
      .get<Datos>(`${ruta}/portada`)
      .then(setDatos)
      .catch((e: ErrorDeApi) => setError(e.message))
  }, [ruta])

  const base = `/${servidor.id}`
  const revisa = puedo('revisar_solicitudes')

  return (
    <>
      <header className="cabecera">
        <h1>Hola, {yo.persona.nombre.split(' ')[0]}</h1>
        <div className="cabecera__acciones">
          <Link className="boton boton--principal" to={`${base}/solicitudes?nueva=1`}>
            Nueva solicitud
          </Link>
        </div>
      </header>

      <div className="contenido">
        {error && <Error>{error}</Error>}
        {!datos && !error && <Cargando filas={4} />}

        {datos && (
          <>
            <div className="rejilla rejilla--cifras" style={{ marginBottom: 20 }}>
              {revisa && (
                <Cifra
                  valor={datos.resumen.solicitudes_sin_mirar ?? 0}
                  etiqueta="Solicitudes sin mirar"
                />
              )}
              <Cifra
                valor={datos.resumen.solicitudes_abiertas ?? 0}
                etiqueta="Solicitudes abiertas"
              />
              {(puedo('llevar_desarrollo') || revisa) && (
                <>
                  <Cifra
                    valor={datos.resumen.solicitudes_por_desarrollar ?? 0}
                    etiqueta="Por desarrollar"
                  />
                  <Cifra valor={datos.resumen.solicitudes_en_curso ?? 0} etiqueta="En curso" />
                  <Cifra
                    valor={datos.resumen.solicitudes_por_cerrar ?? 0}
                    etiqueta="Pendientes de cierre"
                  />
                </>
              )}
              <Cifra valor={datos.resumen.mis_tareas ?? 0} etiqueta="Tareas mías" />
              <Cifra valor={datos.resumen.tareas_vencidas ?? 0} etiqueta="Tareas vencidas" alerta />
              <Cifra valor={datos.resumen.proyectos_activos ?? 0} etiqueta="Proyectos activos" />
              {!revisa && (
                <Cifra
                  valor={datos.resumen.solicitudes_mias ?? 0}
                  etiqueta="Solicitudes mías abiertas"
                />
              )}
            </div>

            <div className="rejilla rejilla--tres">
              <section className="tarjeta">
                <h2 className="tarjeta__titulo">
                  {revisa ? 'Esperando respuesta' : 'Mis solicitudes en curso'}
                </h2>
                {datos.esperando_respuesta.length === 0 ? (
                  <Vacio titulo="Nada pendiente">
                    <p>No hay ninguna solicitud esperando.</p>
                  </Vacio>
                ) : (
                  <ul className="lista">
                    {datos.esperando_respuesta.map((s) => (
                      <li key={s.numero}>
                        <Link className="fila" to={`${base}/solicitudes/${s.numero}`}>
                          <div className="fila__principal">
                            <div className="fila__titulo">{s.titulo}</div>
                            <div className="fila__meta">
                              <span className="codigo">{s.codigo}</span>
                              <span>{s.solicitante?.nombre ?? 'alguien'}</span>
                              <span>{hace(s.creada)}</span>
                            </div>
                          </div>
                          <EtiquetaDeEstado texto={s.estado_texto} />
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </section>

              <section className="tarjeta">
                <h2 className="tarjeta__titulo">Mis tareas</h2>
                {datos.mis_tareas.length === 0 ? (
                  <Vacio titulo="Nada asignado">
                    <p>No tienes ninguna tarea abierta.</p>
                  </Vacio>
                ) : (
                  <ul className="lista">
                    {datos.mis_tareas.map((t) => (
                      <li key={t.numero} className="fila">
                        <div className="fila__principal">
                          <div className="fila__titulo">{t.titulo}</div>
                          <div className="fila__meta">
                            <span className="codigo">{t.codigo}</span>
                            <span>{t.estado_texto}</span>
                            {t.vence && (
                              <span style={{ color: t.vencida ? 'var(--malo)' : undefined }}>
                                vence {fecha(t.vence)}
                              </span>
                            )}
                          </div>
                        </div>
                        <EtiquetaDePrioridad valor={t.prioridad} />
                      </li>
                    ))}
                  </ul>
                )}
              </section>

              <section className="tarjeta">
              <h2 className="tarjeta__titulo">Actividad reciente</h2>
              {datos.actividad.length === 0 ? (
                <Vacio titulo="Todavía no ha pasado nada" />
              ) : (
                <div style={{ padding: '10px 16px' }}>
                  <ul className="historial">
                    {datos.actividad.slice(0, 12).map((linea) => (
                      <li key={linea.id}>
                        {linea.frase}
                        <time dateTime={linea.cuando}>{hace(linea.cuando)}</time>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              </section>
            </div>
          </>
        )}
      </div>
    </>
  )
}
